// Copyright (c) 2016 Deere & Company

import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export function getPinsNotRegisteredColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'pin',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 190
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'description',
            field: 'description',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DESCRIPTION'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'model',
            field: 'model',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('MODEL'),
            width: 100
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'account',
            field: 'account',
            headerClass: classNames.headerClassName,
            headerName: translate('ACCOUNT'),
            width: 100
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'accountName',
            field: 'accountName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'location',
            field: 'location',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('LOCATION'),
            width: 200
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'invoiceDate',
            field: 'invoiceDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('INVOICED'),
            width: 120
        },
        {
            cellClass: classNames.cellRightClassName,
            colId: 'amountOfUse',
            field: 'amountOfUse',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('CURRENT_AMOUNT_OF_USE'),
            width: 200
        },
        {
            cellClass: classNames.cellRightClassName,
            colId: 'daysOnRent',
            field: 'daysOnRent',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('DAYS_ON_RENT'),
            width: 140
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'currentlyOnRent',
            field: 'currentlyOnRent',
            headerClass: classNames.headerClassName,
            headerName: translate('CURRENTLY_ON_RENT'),
            width: 200
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'reportDate',
            field: 'reportDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('REPORT_DATE'),
            width: 160
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/pins-not-registered/report-services/column-definitions.js